import React from 'react';
import { motion } from 'framer-motion';
import { FaUtensils } from 'react-icons/fa';

export const MarqueeButton = () => {
  const children = (
    <div className="flex items-center gap-2 ">
      <FaUtensils /> • Bestellen •{' '}
    </div>
  );
  return (
    <a href="#contact">
      <motion.button
        whileHover={{
          scale: 1.05,
        }}
        whileTap={{
          scale: 0.95,
        }}
        className="relative overflow-hidden rounded-lg bg-[#FAED04] p-4 text-xl font-black uppercase text-neutral-950"
      >
        <motion.span
          className="flex"
          initial={{ x: '0%' }}
          animate={{
            x: 'calc(-100% - 12px)',
          }}
          transition={{
            ease: 'linear',
            duration: 5,
            repeat: Infinity,
            repeatType: 'loop',
          }}
        >
          {children}
        </motion.span>

        <motion.span
          initial={{ x: 'calc(-100% - 6px)' }}
          animate={{
            x: 'calc(-200% - 24px)',
          }}
          transition={{
            ease: 'linear',
            duration: 5,
            repeat: Infinity,
            repeatType: 'loop',
          }}
          className="absolute left-4 top-4 block"
        >
          {children}
        </motion.span>
        <motion.span
          initial={{ x: 'calc(100% + 12px)' }}
          animate={{
            x: '0%',
          }}
          transition={{
            ease: 'linear',
            duration: 5,
            repeat: Infinity,
            repeatType: 'loop',
          }}
          className="absolute left-4 top-4 block"
        >
          {children}
        </motion.span>
        <motion.span
          initial={{ x: 'calc(200% + 24px)' }}
          animate={{
            x: 'calc(100% + 6px)',
          }}
          transition={{
            ease: 'linear',
            duration: 5,
            repeat: Infinity,
            repeatType: 'loop',
          }}
          className="absolute left-4 top-4 block"
        >
          {children}
        </motion.span>
      </motion.button>
    </a>
  );
};
